import { useEffect } from 'react'
import styled from 'styled-components/macro'

import { Section } from 'core/ui/components/section/Section'

import { OfferCard, CONTEXTS } from '../../OfferCard/OfferCard'
import { TopOffersCarousel } from './TopOffersCarousel'
import { REQUEST_STATUS } from './topOffersReducer'
import { useTopOffers } from './useTopOffers'

const TopOfferCard = styled(OfferCard)`
  height: 100%;
`

function TopOffers(props) {
  const { topOffers, status, fetchTopOffers } = useTopOffers()
  const shouldForceMobile = topOffers?.length > 1

  useEffect(() => {
    if (status !== REQUEST_STATUS.EMPTY) return
    fetchTopOffers()
  }, [fetchTopOffers, status])

  if (!topOffers?.length) {
    return null
  }

  return (
    <Section
      title="Recommended Loads for you"
      subtitle="This is a recommended load based on your profile preferences"
      {...props}
    >
      <TopOffersCarousel>
        {topOffers.map(offer => (
          <TopOfferCard
            key={offer.load.ref_number || offer.load.loadsmart_ref_number || offer.load.uuid}
            loadOffer={offer}
            context={CONTEXTS.TOP_OFFERS}
            forceMobile={shouldForceMobile}
            displayChat={false}
            showOnlyTwoStops
            showFeedback
            isRelatedLoad
          />
        ))}
      </TopOffersCarousel>
    </Section>
  )
}

export { TopOffers }
